<template>
  <div :class="{ 'has-logo': showLogo }">
    <logo v-if="showLogo" :collapse="isCollapse" />
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <!-- :active-text-color="variables.menuActiveText" -->
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="true"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in sidebar.menu.menuList"
          :key="route.path"
          :item="route"
          :base-path="route.path || route.link"
        />
      </el-menu>
    </el-scrollbar>

    <!-- Toggle Sidebar -->
    <div class="sidebar-toggle-btn" @click="toggleSideBar">
      <i class="icon-arrow-back" />
    </div>
    <div>
      <!-- <svg :class="['icon']" :fill="color" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"> -->
      <!-- </svg> -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from './Logo'
import SidebarItem from './SidebarItem'
import variables from '@/styles/variables.scss'
// eslint-disable-next-line no-unused-vars
// import Routeee from '@/routeee.js'
// import { getMenuListApi } from '@/api/auth_service/authManage'

export default {
  components: { SidebarItem, Logo },
  data() {
    return {
      // routeee: []
    }
  },
  computed: {
    ...mapGetters(['permission_routes', 'sidebar']),
    iconPath() {
      return require(`@/styles/images/svg/mci_arrow-back.svg`)
    },
    activeMenu() {
      let activePath
      const route = this.$route
      // eslint-disable-next-line no-unused-vars
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set

      if (meta.activeMenu) {
        activePath = meta.activeMenu
      } else {
        activePath = path
      }

      if (activePath.split('/').length - 1 > 3) {
        const idx = activePath.lastIndexOf('/')
        activePath = activePath.slice(0, idx)
      }

      return activePath
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo
    },
    variables() {
      return variables
    },
    isCollapse() {
      return !this.sidebar.opened
      // return true
    }
  },
  mounted() {
    // this.routeee = Routeee
    // this.fnGetRouteList()
    // console.log('HIHI5: ', this.routeee)
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('app/toggleSideBar')
    }
    // async fnGetRouteList() {
    //   await getMenuListApi().then((res) => {
    //     console.log('Route', res)
    //     this.routeee = res.data
    //   })
    // }
  }
}
</script>
